<div class="locker-order">
    <div class="locker-order-header">
        <span>{{ 'locker.cart.order_created_at' | translate:{'date': order.createdAt | date:'short'} }}</span>
        <span matBadge>{{ 'locker.cart.status_' + order.status | translate }}</span>
    </div>
    <div class="locker-order-body">
        <div class="locker-order-body-info">
            <div class="locker-order-body-info-image">
                <img src="{{ order.spirit.catalogSpirit.image | spiritImage }}"/>
            </div>
            <div class="locker-order-body-info-details">
                <span>{{ order.spirit.catalogSpirit.name }}</span>
                <small>{{ order.spirit | spiritTranslation:'subname' }}</small>
                <small>
                    <em>
                        @if (order.spirit.catalogSpirit.type) {
                            {{ order.spirit.catalogSpirit.type | catalogTranslation }}
                        }
                        @if (order.spirit.catalogSpirit.type && order.spirit.catalogSpirit.region) {
                            -
                        }
                        @if (order.spirit.catalogSpirit.region) {
                            {{ order.spirit.catalogSpirit.region | catalogTranslation }}
                        }
                    </em>
                </small>
            </div>
        </div>
        @if (order.price) {
            <span>{{ 'locker.cart.total' | translate }}: {{ order.price }}{{ menu.currency?.symbol }} x {{ order.quantity }} = <b>{{ toFixed(order.price * order.quantity) }}{{ menu.currency?.symbol }}</b></span>
        } @else {
            <span>{{ 'locker.cart.agreed_price' | translate }}</span>
        }
    </div>
</div>